import {
  SettingOsChannelModeRequest,
  SettingOsChannelModeDirectScheduling,
} from '@weave/schema-gen-ts/dist/schemas/schedule/v3/setting.pb';
import { i18next } from '@frontend/i18n';
import { SchedulingMode } from './types';

export const DEFAULT_SCHEDULING_MODE: SchedulingMode = 'REQUEST';

export const SCHEDULING_MODE_OPTIONS: { value: SchedulingMode; label: string }[] = [
  { value: SettingOsChannelModeRequest, label: i18next.t('Request Scheduling', { ns: 'schedule-settings' }) },
  { value: SettingOsChannelModeDirectScheduling, label: i18next.t('Direct Booking', { ns: 'schedule-settings' }) },
];
